import axios from "axios";
import { ADMIN_PERMISSIONS_ENDPOINT } from "../../../../constants/endpoints";
import { ResponseModel } from "../../../../models/ResponseModel";


export function getList() {
    return axios.get<ResponseModel>(`${ADMIN_PERMISSIONS_ENDPOINT}`);
}